import React from 'react'
import Img from 'gatsby-image'

import Icon from '@/icons'
import LargeText from '@/large-text'
import Testimonial from '@/testimonial'

import './styles.css'

const BrandInfo = ({
  brandText,
  mainImgSrc,
  logoSrc,
  brandName,
  avatarSrc,
  personName,
  personStatus,
  personText,
  yearStarted,
  votes,
  castings,
  ratings
}) => {
  return (
    <div className="mb7 mw800 center">
      <div className="flex-m flex-wrap mb5">
        <div className="center ml0-m mr3-m mr5-l flex-grow-1 mw197">
          <Img sizes={mainImgSrc} alt="" />
        </div>

        <div className="flex-grow-1 flex-basis-0">
          <Img sizes={logoSrc} alt="" className="w68 h68" />
          <h3 className="f3 f2-m f1-l fw5 mt0 mb2">{brandName}</h3>

          <ul className="list mv0 mh--3 flex flex-wrap items-end">
            {yearStarted && (
              <ListItem iconName="time" title={yearStarted} text="Year started" />
            )}
            {votes && (
              <ListItem iconName="starFilled" title={votes} text="votes" />
            )}
            {castings && (
              <ListItem iconName="masks" title={castings} text="castings" />
            )}
            {ratings && (
              <ListItem iconName="rating" title={ratings} text="judge ratings" />
            )}
            <ListItem
              iconName="dollar"
              title={<Icon icon="check-simple" height="18px" className="green db" />}
              text="new revenue"
            />
          </ul>

          <LargeText align="left">
            {brandText}
          </LargeText>
        </div>
      </div>

      <div className="mw740 center flex">
        <Testimonial
          avatarSrc={avatarSrc}
          name={personName}
          status={personStatus}
          comment={personText}
        />
        <Img sizes={mainImgSrc} alt="" />
      </div>
    </div>
  )
}

const ListItem = ({ iconName, title, text }) => {
  return (
    <li className="mh3 mb3">
      <div className="flex items-center mb1">
        <Icon icon={iconName} height="18px" className="gold mr2" />
        <div className="f6 fw3 lh-solid">{title}</div>
      </div>
      <div className="f11 nowrap">{text}</div>
    </li>
  )
}

export default BrandInfo



// WEBPACK FOOTER //
// ./src/components/section-case-studies/brand-info/brand-info.js